import * as React from "react"
const ExitIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#D24B4E"
      d="M1.333 14.5v-12A.667.667 0 0 1 2 1.833h3.333V.5H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3.333v-1.333H2a.667.667 0 0 1-.667-.667Z"
    />
    <path
      fill="#D24B4E"
      d="m15.415 7.086-3.057-3.057-.943.942 2.843 2.843-10.925.02v1.333l10.963-.02-2.882 2.882.943.942 3.057-3.057a2 2 0 0 0 .002-2.828Z"
    />
  </svg>
)
export default ExitIcon
